import cn from "@/util/cn";
import { ComponentPropsWithoutRef } from "react";

export type CellProps = {
  outline?: boolean;
} & ComponentPropsWithoutRef<"div">;

export const Cell = ({ className, children, outline = false, ...otherProps }: CellProps) => {
  return (
    <div
      className={cn(
        outline ? "outline-solid outline-1 outline-gray-300" : "",
        "print:break-inside-avoid-page",
        className
      )}
      {...otherProps}
    >
      {children}
    </div>
  );
};

export const HeaderCell = ({ className, ...otherProps }: CellProps) =>
  Cell({
    className: cn("flex justify-center p-2 text-center font-semibold", className),
    outline: true,
    ...otherProps,
  });
